import { post, get } from '@/request/request'

import { IBaseRespone } from 'types/api'

// 获取当前员工授权的授权码
export function getCurrentAuthCode() {
  return post<IBaseRespone<{
		id: number;
		authCode: string;
    beginTime: string;
    endTime: string;
	}>>(
    '/api/tm/unified-login/v5/admin/authcode/get',
    {}
  )
}

// 生成用户授权的授权码
export function createAuthCode(
  params: {
    duration: number // 授权时长选项:1(12小时), 2(1天), 3(7天)
    product?: string // 授权来源产品线, scm(供应链), erpx(Y)
  }
) {
  return post<IBaseRespone<any>>(
    '/api/tm/unified-login/v5/admin/authcode/create',
    params
  )
}

// 终止用户授权的授权码
export function terminateAuthCode(
  params: {
    authCodeId: number
  }
) {
  return post<IBaseRespone<any>>(
    '/api/tm/unified-login/v5/admin/authcode/terminate',
    params
  )
}

// (安全中心接口)获取租户下员工的技术支持授权记录
export function getAuthPageApi(
  params: {
    currentMerchantId: string
    currentNickName: string
    flag: number
    pageSize: number
    pageNum: number
    keyword: string
    beginTime: string
    endTime: string
  }
) {
  return post<IBaseRespone<any>>(
    '/api/tm/unified-login/v2/auth/tenant/ts/auth/page',
    params
  )
}

// 管理员终止用户授权的授权码
export function terminateAuthCodeOfAuthApi(
  params: {
    authCodList: Array<string>
  }
) {
  return post<IBaseRespone<any>>(
    '/api/tm/unified-login/v2/auth/tenant/ts/admin/authCode-terminate',
    params
  )
}

// 授权码登录
export function loginBizByAuthTs(
  params: {
    authCode: string //授权码
  }
) {
  return post<IBaseRespone<string>>(
    '/open/tm/unified-login/v5/admin/ts/loginBiz',
    params
  )
}

// 登录验证
export function checkAndGetOaUrl() {
  return get<IBaseRespone<string>>(
    '/open/tm/unified-login/v5/admin/ts/checkAndGetOaUrl',
    {}
  )
}


// 登录验证
// export function getredirctUrl(params: {}) {
//   return get<IBaseRespone<any>>(
//     'api/tm/unified-login/v4/open/inner/qrcode/redirect',
//     params
//   )
// }
